<template>
  <div class="notificationMessage">
    <div class="notificationMessage__header">
      <ul class="notificationMessage__header__tab">
        <li class="notificationMessage__header__title">通知消息</li>
        <span class="notificationMessage__header__arrow" :style="`left:${arrow_offsetLeft}px`"></span>
      </ul>
    </div>
    <div class="notificationMessage__items">
      <MessageItem v-for="(item, index) in data" :key="index" :dic="item" :username="username" :owner-info="userInfo" source="notification" />
    </div>
    <!-- 选奖品的弹窗 -->
    <div class="mask" v-if="showMask">
      <div class="block">
        <div class="content">
          <div class="title">请选择奖品</div>
          <div class="radio">
            <el-radio-group v-model="prizeVal">
              <el-radio v-for="item in prizeList" :label="item.id" :key="item.id">
                <span class="name">{{item.name}}</span>
                <img :src="item.image_url">
              </el-radio>
            </el-radio-group>
          </div>
          <div class="btn">
            <button @click="prizeTake()">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { POST, GET } from '@/utils/request'
// @ is an alias to /src
import MessageItem from "./MessageItem";

import { types as MessageTypes } from "@/store/modules/message";
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as ToastTypes } from "@/store/modules/toast";

export default {
  name: "MoblieNotificationMessage",
  components: {
    MessageItem
  },
  data () {
    return {
      arrow_offsetLeft: 40,
      fromType: "notification",

      //礼品
      record: null,
      activityNumber: null,
      showMask: false,
      prizeVal: '',
      prizeList: []
    };
  },
  computed: {
    ...mapState({
      username: state => state.login.username,
      userInfo: state => state.login.userInfo,
      page: state => state.message.page,
      load_more: state => state.message.load_more,
    }),
    ...mapGetters({
      data: MessageTypes.GETTER_LIST_MESSAGE
    })
  },

  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW,
    }),
    ...mapActions({
      fetchData: MessageTypes.FETCH_LIST_MESSAGE,
    }),

    handleScroll (e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchData({ page: that.page + 1, from: that.fromType })
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },
    async getPrize () {
      let detail = await GET(`/server/show/showwork_grade_detail/${this.activityNumber}/${this.record}/`)
      if (detail.prize) {
        this.$message("该奖品您已经选择啦，请等待老师寄出吧")
        return
      }
      let grade = detail.grade
      this.showMask = true
      let response = await GET('/server/show/prize_list/', {
        activity_number: this.activityNumber,
        grade: grade
      })
      this.prizeList = response.results

    },
    async prizeTake () {
      let res = await POST('/server/show/prize_take/', {
        record: this.record,
        prize: this.prizeVal
      })
      if (res.status === 0) {
        this.$message.success('您已经成功领取你的奖品，请等待班主任安排寄出')
        this.showMask = false
      }

    }
  },
  created () {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$route.query.number && this.$route.query.record) {
      this.activityNumber = this.$route.query.number
      this.record = this.$route.query.record
      this.getPrize()
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted () {
    this.fetchData({ page: 1, from: this.fromType })
  }
};
</script>

<style lang="less" scoped>
.notificationMessage {
  width: 100%;
}
.notificationMessage__header {
  width: 100%;
  /* height: 38px; */
  margin: 0 0 10px;
  box-shadow: -1px 0 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.04),
    1px 0 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  font-size: 12px;
  color: #333333;
}
.notificationMessage__header__tab {
  width: 300px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.notificationMessage__header__title {
  width: 142px;
  margin: 0 -2px 0 20px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  height: 38px;
  line-height: 38px;
  /* font-weight: bold; */
  font-size: 12px;
  cursor: pointer;
}
.notificationMessage__header__arrow {
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -7px;
  left: 40px;
  background-color: #ff6600;
  background-color: #f2f2f5;
}
.mask {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .block {
    width: 40rem;
    background: #6b45e1;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.5rem;
    padding: 0.5rem;
    .content {
      background: white;
      border-radius: 0.5rem;
      text-align: center;
      overflow: hidden;
      .title {
        font-size: 1.3rem;
        margin-top: 1.8rem;
        margin-bottom: 1.5rem;
      }
      .btn {
        margin-top: 1.5rem;
        margin-bottom: 2.5rem;
        button {
          background: #774ee5;
          color: #fff;
          font-size: 1.4rem;
          height: 2.5rem;
          border-radius: 1.25rem;
          padding: 0 2rem;
          cursor: pointer;
        }
      }
    }
    /deep/.el-radio-group {
      display: flex;
      justify-content: space-around;
      .el-radio {
        display: flex;
        flex-direction: column-reverse;
        .name {
          font-size: 1rem;
        }
        img {
          height: 9rem;
          width: 9rem;
          display: block;
          margin-bottom: 1rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}
</style>
